import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  // SiVisualstudiocode,
  SiPostman,
  SiRabbitmq,
  SiDocker,
  SiGithub
} from "react-icons/si";
// import { IoLogoVercel } from "react-icons/io5";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiLinux />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <SiGithub />
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
      <SiRabbitmq />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
      <SiDocker />
      </Col>

    </Row>
  );
}

export default Toolstack;
